module.exports = __webpack_public_path__ + "img/pierre_h.0847f678.png";